import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterModule, FooterComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  host: {
    class: 'min-vh-100 d-flex flex-column',
  },
})
export class AuthLayoutComponent {}
